import { Component, Input } from '@angular/core';
import { TwitterElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-twitter-element-preview',
  templateUrl: './twitter-element-preview.component.html',
  styleUrls: ['./twitter-element-preview.component.scss'],
})
export class TwitterElementPreviewComponent {
  @Input() public element: TwitterElementPreviewFragment;
}
